// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  ActivitiesActivitityFeedData,
  ActivitiesActivitityFeedError,
  ActivitiesActivitityFeedResponse,
  ActivitiesCancelLikeWorkData,
  ActivitiesCancelLikeWorkError,
  ActivitiesGetActivityData,
  ActivitiesGetActivityError,
  ActivitiesGetActivityResponse,
  ActivitiesGetCampaignData,
  ActivitiesGetCampaignError,
  ActivitiesGetCampaignResponse,
  ActivitiesGetWorkData,
  ActivitiesGetWorkError,
  ActivitiesGetWorkResponse,
  ActivitiesLikeWorkData,
  ActivitiesLikeWorkError,
  ActivitiesListActivitiesData,
  ActivitiesListActivitiesError,
  ActivitiesListActivitiesResponse,
  ActivitiesListWorksData,
  ActivitiesListWorksError,
  ActivitiesListWorksResponse,
  ActivitiesSignupActivityData,
  ActivitiesSignupActivityError,
  ActivitiesSubmitWorkData,
  ActivitiesSubmitWorkError,
  ActivitiesSubmitWorkResponse,
  AgentChatData,
  AgentChatError,
  AgentChatResponse,
  AgentChatStreamData,
  AgentChatStreamError,
  AgentChatStreamResponse,
  AgentCreateSessionData,
  AgentCreateSessionError,
  AgentCreateSessionResponse,
  AgentDeleteSessionData,
  AgentDeleteSessionError,
  AgentGetChatHistoryData,
  AgentGetChatHistoryError,
  AgentGetChatHistoryResponse,
  AgentListModelsData,
  AgentListModelsError,
  AgentListModelsResponse,
  AgentListVoicesData,
  AgentListVoicesError,
  AgentListVoicesResponse,
  AgentRegenerateTtsData,
  AgentRegenerateTtsError,
  AgentRegenerateTtsResponse,
  AppReviewGetReviewModeData,
  AppReviewGetReviewModeError,
  AppReviewGetReviewModeResponse,
  AppUpgradeGetUpgradeConfigData,
  AppUpgradeGetUpgradeConfigError,
  AppUpgradeGetUpgradeConfigResponse,
  BattlesActivityResultData,
  BattlesActivityResultError,
  BattlesActivityResultResponse,
  BattlesGetActivityBarrageData,
  BattlesGetActivityBarrageError,
  BattlesGetActivityBarrageResponse,
  BattlesGetExcellentSubmissionsData,
  BattlesGetExcellentSubmissionsError,
  BattlesGetExcellentSubmissionsResponse,
  BattlesGetStatsData,
  BattlesGetStatsError,
  BattlesGetStatsResponse,
  BattlesGetUserSignupInfoData,
  BattlesGetUserSignupInfoError,
  BattlesGetUserSignupInfoResponse,
  BattlesSignupActivityData,
  BattlesSignupActivityError,
  CanvasesCreateData,
  CanvasesCreateError,
  CanvasesCreateResponse,
  CanvasesGetData,
  CanvasesGetError,
  CanvasesGetResponse,
  ClipComposeData,
  ClipComposeError,
  ClipComposeResponse,
  ClipCreateProjectData,
  ClipCreateProjectError,
  ClipCreateProjectResponse,
  ClipDeleteProjectData,
  ClipDeleteProjectError,
  ClipExportByProjectData,
  ClipExportByProjectError,
  ClipExportByProjectResponse,
  ClipGetProjectByTaskIdData,
  ClipGetProjectByTaskIdError,
  ClipGetProjectByTaskIdResponse,
  ClipGetProjectData,
  ClipGetProjectError,
  ClipGetProjectResponse,
  ClipListJobsData,
  ClipListJobsError,
  ClipListJobsResponse,
  ClipListProjectsData,
  ClipListProjectsError,
  ClipListProjectsResponse,
  ClipRegisterMediaData,
  ClipRegisterMediaError,
  ClipRegisterMediaResponse,
  ClipSaveAndExportData,
  ClipSaveAndExportError,
  ClipSaveAndExportResponse,
  ClipUpdateProjectData,
  ClipUpdateProjectError,
  ClipUpdateProjectResponse,
  ContainersActionData,
  ContainersActionError,
  ContainersActionResponse,
  ContainersGetShareDetailData,
  ContainersGetShareDetailError,
  ContainersGetShareDetailResponse,
  ContainersGetShareTokenData,
  ContainersGetShareTokenError,
  ContainersGetShareTokenResponse,
  ContainersListData,
  ContainersListError,
  ContainersListResponse,
  ContainersMergeClipsData,
  ContainersMergeClipsError,
  ContainersMergeClipsResponse,
  ContainersOpenStoryboardContainersData,
  ContainersOpenStoryboardContainersError,
  ContainersOpenStoryboardContainersResponse,
  ContainersRandomMusicData,
  ContainersRandomMusicError,
  ContainersRandomMusicResponse,
  ContainersUpdateData,
  ContainersUpdateError,
  ContainersUpdateResponse,
  CreationsBatchDeleteData,
  CreationsBatchDeleteError,
  CreationsBatchGetWatermarkResourceData,
  CreationsBatchGetWatermarkResourceError,
  CreationsBatchGetWatermarkResourceResponse,
  CreationsDeleteData,
  CreationsDeleteError,
  CreationsDetailData,
  CreationsDetailError,
  CreationsDetailResponse,
  CreationsGetMyData,
  CreationsGetMyError,
  CreationsGetMyResponse,
  CreationsGetShareDetailData,
  CreationsGetShareDetailError,
  CreationsGetShareDetailResponse,
  CreationsGetShareTokenData,
  CreationsGetShareTokenError,
  CreationsGetShareTokenResponse,
  CustomizeAddData,
  CustomizeAddError,
  CustomizeAddResponse,
  CustomizeDeleteData,
  CustomizeDeleteError,
  CustomizeGetData,
  CustomizeGetError,
  CustomizeGetResponse,
  CustomizeRemoveData,
  CustomizeRemoveError,
  CustomizeRemoveResponse,
  CustomizeSetData,
  CustomizeSetError,
  CustomizeSetResponse,
  EarnCreateWithdrawData,
  EarnCreateWithdrawError,
  EarnCreateWithdrawResponse,
  EarnGetActivityData,
  EarnGetActivityError,
  EarnGetActivityResponse,
  EarnGetMyData,
  EarnGetMyError,
  EarnGetMyResponse,
  EarnListCampionsData,
  EarnListCampionsError,
  EarnListCampionsResponse,
  EarnListEarnActivitiesData,
  EarnListEarnActivitiesError,
  EarnListEarnActivitiesResponse,
  EarnListMySubmitsData,
  EarnListMySubmitsError,
  EarnListMySubmitsResponse,
  EarnListMyWithdrawsData,
  EarnListMyWithdrawsError,
  EarnListMyWithdrawsResponse,
  EarnSubmitApplyData,
  EarnSubmitApplyError,
  EarnSubmitApplyResponse,
  EarnSubmitWorkData,
  EarnSubmitWorkError,
  EarnSubmitWorkResponse,
  InspirationsCreateMediaAssetData,
  InspirationsCreateMediaAssetError,
  InspirationsCreateMediaAssetResponse,
  InspirationsCreateMiniVideoData,
  InspirationsCreateMiniVideoError,
  InspirationsCreateMiniVideoResponse,
  InspirationsCreateShortFilmData,
  InspirationsCreateShortFilmError,
  InspirationsCreateShortFilmResponse,
  InspirationsGetCollectInspirationsData,
  InspirationsGetCollectInspirationsError,
  InspirationsGetCollectInspirationsListData,
  InspirationsGetCollectInspirationsListError,
  InspirationsGetCollectInspirationsListResponse,
  InspirationsGetCollectInspirationsResponse,
  InspirationsGetInspirationDetailData,
  InspirationsGetInspirationDetailError,
  InspirationsGetInspirationDetailResponse,
  InspirationsGetInspirationIdsForSeoData,
  InspirationsGetInspirationIdsForSeoError,
  InspirationsGetInspirationIdsForSeoResponse,
  InspirationsGetInspirationShareDetailData,
  InspirationsGetInspirationShareDetailError,
  InspirationsGetInspirationShareDetailResponse,
  InspirationsGetInspirationShareTokenData,
  InspirationsGetInspirationShareTokenError,
  InspirationsGetInspirationShareTokenResponse,
  InspirationsGetLikeInspirationsData,
  InspirationsGetLikeInspirationsError,
  InspirationsGetLikeInspirationsListData,
  InspirationsGetLikeInspirationsListError,
  InspirationsGetLikeInspirationsListResponse,
  InspirationsGetLikeInspirationsResponse,
  InspirationsGetMyInspirationsData,
  InspirationsGetMyInspirationsError,
  InspirationsGetMyInspirationsListData,
  InspirationsGetMyInspirationsListError,
  InspirationsGetMyInspirationsListResponse,
  InspirationsGetMyInspirationsResponse,
  InspirationsGetPersonaInspirationsData,
  InspirationsGetPersonaInspirationsError,
  InspirationsGetPersonaInspirationsListData,
  InspirationsGetPersonaInspirationsListError,
  InspirationsGetPersonaInspirationsListResponse,
  InspirationsGetPersonaInspirationsResponse,
  InspirationsMediaAssetFeedData,
  InspirationsMediaAssetFeedError,
  InspirationsMediaAssetFeedResponse,
  InspirationsShortFilmFeedData,
  InspirationsShortFilmFeedError,
  InspirationsShortFilmFeedResponse,
  MaterialsBatchDeleteElementData,
  MaterialsBatchDeleteElementError,
  MaterialsBatchGetElementsData,
  MaterialsBatchGetElementsError,
  MaterialsBatchGetElementsResponse,
  MaterialsBatchHistoryElementsData,
  MaterialsBatchHistoryElementsError,
  MaterialsBatchHistoryElementsResponse,
  MaterialsCancelElementTaskData,
  MaterialsCancelElementTaskError,
  MaterialsCancelShareElementData,
  MaterialsCancelShareElementError,
  MaterialsClaimRewardData,
  MaterialsClaimRewardError,
  MaterialsClaimRewardResponse,
  MaterialsCopyFromShareData,
  MaterialsCopyFromShareError,
  MaterialsCopyFromShareResponse,
  MaterialsCreateElementCheckData,
  MaterialsCreateElementCheckError,
  MaterialsCreateElementCheckResponse,
  MaterialsCreateElementData,
  MaterialsCreateElementError,
  MaterialsCreateElementResponse,
  MaterialsCreateElementTaskData,
  MaterialsCreateElementTaskError,
  MaterialsCreateElementTaskResponse,
  MaterialsCreateLabelData,
  MaterialsCreateLabelError,
  MaterialsCreateLabelResponse,
  MaterialsCreateMotionData,
  MaterialsCreateMotionError,
  MaterialsCreateMotionResponse,
  MaterialsCreateVoiceData,
  MaterialsCreateVoiceError,
  MaterialsCreateVoiceResponse,
  MaterialsDeleteElementData,
  MaterialsDeleteElementError,
  MaterialsDeleteLabelData,
  MaterialsDeleteLabelError,
  MaterialsDeleteMotionData,
  MaterialsDeleteMotionError,
  MaterialsGetElementCreationsData,
  MaterialsGetElementCreationsError,
  MaterialsGetElementCreationsResponse,
  MaterialsGetElementData,
  MaterialsGetElementDetailData,
  MaterialsGetElementDetailError,
  MaterialsGetElementDetailResponse,
  MaterialsGetElementError,
  MaterialsGetElementResponse,
  MaterialsGetElementTaskStateData,
  MaterialsGetElementTaskStateError,
  MaterialsGetElementTaskStateResponse,
  MaterialsGetHistoryElementDetailData,
  MaterialsGetHistoryElementDetailError,
  MaterialsGetHistoryElementDetailResponse,
  MaterialsGetLastReviewedShareElementData,
  MaterialsGetLastReviewedShareElementError,
  MaterialsGetLastReviewedShareElementResponse,
  MaterialsGetMotionData,
  MaterialsGetMotionError,
  MaterialsGetMotionResponse,
  MaterialsGetMyElementsData,
  MaterialsGetMyElementsError,
  MaterialsGetMyElementsResponse,
  MaterialsGetMyElementsV2Data,
  MaterialsGetMyElementsV2Error,
  MaterialsGetMyElementsV2Response,
  MaterialsGetMyShareElementsData,
  MaterialsGetMyShareElementsError,
  MaterialsGetMyShareElementsResponse,
  MaterialsGetPersonaShareElementsData,
  MaterialsGetPersonaShareElementsError,
  MaterialsGetPersonaShareElementsResponse,
  MaterialsGetRankingData,
  MaterialsGetRankingError,
  MaterialsGetRankingResponse,
  MaterialsGetShareCategoriesData,
  MaterialsGetShareCategoriesError,
  MaterialsGetShareCategoriesResponse,
  MaterialsGetVoiceData,
  MaterialsGetVoiceError,
  MaterialsGetVoiceResponse,
  MaterialsGetVoiceStatusData,
  MaterialsGetVoiceStatusError,
  MaterialsGetVoiceStatusResponse,
  MaterialsListElementsData,
  MaterialsListElementsError,
  MaterialsListElementsResponse,
  MaterialsListElementTaskHistoryData,
  MaterialsListElementTaskHistoryError,
  MaterialsListElementTaskHistoryResponse,
  MaterialsListLabelsData,
  MaterialsListLabelsError,
  MaterialsListLabelsResponse,
  MaterialsListMotionsData,
  MaterialsListMotionsError,
  MaterialsListMotionsResponse,
  MaterialsListPersonalElementsData,
  MaterialsListPersonalElementsError,
  MaterialsListPersonalElementsResponse,
  MaterialsListPopularElementsData,
  MaterialsListPopularElementsError,
  MaterialsListPopularElementsResponse,
  MaterialsListRecommendElementsData,
  MaterialsListRecommendElementsError,
  MaterialsListRecommendElementsResponse,
  MaterialsListVoicesData,
  MaterialsListVoicesError,
  MaterialsListVoicesResponse,
  MaterialsListVoiceTasksData,
  MaterialsListVoiceTasksError,
  MaterialsListVoiceTasksResponse,
  MaterialsPreProcessElementData,
  MaterialsPreProcessElementError,
  MaterialsPreProcessElementResponse,
  MaterialsShareElementsFeedData,
  MaterialsShareElementsFeedError,
  MaterialsShareElementsFeedResponse,
  MaterialsSubmitShareElementData,
  MaterialsSubmitShareElementError,
  MaterialsSubmitShareElementResponse,
  MaterialsUnclaimedRewardData,
  MaterialsUnclaimedRewardError,
  MaterialsUnclaimedRewardResponse,
  MaterialsUpdateElementData,
  MaterialsUpdateElementError,
  MaterialsUpdateElementResponse,
  MaterialsUpdateMotionData,
  MaterialsUpdateMotionError,
  MaterialsUpdateMotionResponse,
  MaterialsUpdateVoiceData,
  MaterialsUpdateVoiceError,
  MaterialsUpdateVoiceResponse,
  MissionCenterGetMissionQuotaData,
  MissionCenterGetMissionQuotaError,
  MissionCenterGetMissionQuotaResponse,
  MissionCenterReportAdEventData,
  MissionCenterReportAdEventError,
  MissionCenterReportAdEventResponse,
  NotificationsGetSysNotificationData,
  NotificationsGetSysNotificationError,
  NotificationsGetSysNotificationResponse,
  NotificationsGetUnreadCountData,
  NotificationsGetUnreadCountError,
  NotificationsGetUnreadCountResponse,
  NotificationsInteractionListData,
  NotificationsInteractionListError,
  NotificationsInteractionListResponse,
  NotificationsListSysNotificationsData,
  NotificationsListSysNotificationsError,
  NotificationsListSysNotificationsResponse,
  NotificationsReadSysNotificationsData,
  NotificationsReadSysNotificationsError,
  OfflineAvatarsCheckCreateUserOfflineAvatarData,
  OfflineAvatarsCheckCreateUserOfflineAvatarError,
  OfflineAvatarsCheckCreateUserOfflineAvatarResponse,
  OfflineAvatarsCreateUserOfflineAvatarData,
  OfflineAvatarsCreateUserOfflineAvatarError,
  OfflineAvatarsCreateUserOfflineAvatarResponse,
  OfflineAvatarsDeleteUserOfflineAvatarData,
  OfflineAvatarsDeleteUserOfflineAvatarError,
  OfflineAvatarsGetUserOfflineAvatarData,
  OfflineAvatarsGetUserOfflineAvatarError,
  OfflineAvatarsGetUserOfflineAvatarResponse,
  OfflineAvatarsListUserOfflineAvatarsData,
  OfflineAvatarsListUserOfflineAvatarsError,
  OfflineAvatarsListUserOfflineAvatarsResponse,
  OfflineAvatarsUpdateUserOfflineAvatarData,
  OfflineAvatarsUpdateUserOfflineAvatarError,
  OfflineAvatarsUpdateUserOfflineAvatarResponse,
  ProjectsCreateData,
  ProjectsCreateError,
  ProjectsCreateResponse,
  ProjectsGetData,
  ProjectsGetError,
  ProjectsGetMyData,
  ProjectsGetMyError,
  ProjectsGetMyResponse,
  ProjectsGetResponse,
  ProjectsGetViralGrowthInfoData,
  ProjectsGetViralGrowthInfoError,
  ProjectsGetViralGrowthInfoResponse,
  ProjectsListShowCaseData,
  ProjectsListShowCaseError,
  ProjectsListShowCaseResponse,
  ProjectsUpdateData,
  ProjectsUpdateError,
  ProjectsUpdateResponse,
  ProjectsUseShowCaseData,
  ProjectsUseShowCaseError,
  ProjectsUseShowCaseResponse,
  SharingGetShareDataData,
  SharingGetShareDataError,
  SharingGetShareDataResponse,
  SharingGetShareOptionsData,
  SharingGetShareOptionsError,
  SharingGetShareOptionsResponse,
  SharingGetUserShareViralChlgData,
  SharingGetUserShareViralChlgError,
  SharingGetUserShareViralChlgResponse,
  SharingGetWechatSignatureData,
  SharingGetWechatSignatureError,
  SharingGetWechatSignatureResponse,
  SquareGetSquareContentData,
  SquareGetSquareContentError,
  SquareGetSquareContentResponse,
  SquareGetThemedEventData,
  SquareGetThemedEventError,
  SquareGetThemedEventPopupData,
  SquareGetThemedEventPopupError,
  SquareGetThemedEventPopupResponse,
  SquareGetThemedEventResponse,
  SquareThemedEventLandingData,
  SquareThemedEventLandingError,
  SquareThemedEventLandingResponse,
  TasksCancelData,
  TasksCancelError,
  TasksCountData,
  TasksCountError,
  TasksCountResponse,
  TasksCreateByCraftData,
  TasksCreateByCraftError,
  TasksCreateByCraftResponse,
  TasksCreateByToolData,
  TasksCreateByToolError,
  TasksCreateByToolResponse,
  TasksCreateData,
  TasksCreateError,
  TasksCreateResponse,
  TasksDeleteData,
  TasksDeleteError,
  TasksGetCostConfigData,
  TasksGetCostConfigError,
  TasksGetCostConfigResponse,
  TasksGetData,
  TasksGetError,
  TasksGetMyTaskHistoryData,
  TasksGetMyTaskHistoryError,
  TasksGetMyTaskHistoryResponse,
  TasksGetResponse,
  TasksGetStateData,
  TasksGetStateError,
  TasksGetStateResponse,
  TasksGetTaskCreditsData,
  TasksGetTaskCreditsError,
  TasksGetTaskCreditsResponse,
  TasksGetTeamQuotaData,
  TasksGetTeamQuotaError,
  TasksGetTeamQuotaResponse,
  TasksGetUserQuotaData,
  TasksGetUserQuotaError,
  TasksGetUserQuotaResponse,
  TasksListRemixStylesData,
  TasksListRemixStylesError,
  TasksListRemixStylesResponse,
  TasksMiniCreateData,
  TasksMiniCreateError,
  TasksMiniCreateResponse,
  TasksRecaptionData,
  TasksRecaptionError,
  TasksRecaptionResponse,
  TemplatesGetActivityTemplateData,
  TemplatesGetActivityTemplateError,
  TemplatesGetActivityTemplateResponse,
  TemplatesGetData,
  TemplatesGetError,
  TemplatesGetResponse,
  TemplatesListCategoriesData,
  TemplatesListCategoriesError,
  TemplatesListCategoriesResponse,
  TemplatesListData,
  TemplatesListError,
  TemplatesListEventTemplatesData,
  TemplatesListEventTemplatesError,
  TemplatesListEventTemplatesResponse,
  TemplatesListResponse,
  TemplatesListTemplateGroupsData,
  TemplatesListTemplateGroupsError,
  TemplatesListTemplateGroupsResponse,
  UsersGetMyFollowersData,
  UsersGetMyFollowersError,
  UsersGetMyFollowersResponse,
  UsersGetMyFollowingsData,
  UsersGetMyFollowingsError,
  UsersGetMyFollowingsResponse,
  UsersGetMyStatData,
  UsersGetMyStatError,
  UsersGetMyStatResponse,
  UsersGetPersonaData,
  UsersGetPersonaError,
  UsersGetPersonaResponse,
  ViduExpandPromptsData,
  ViduExpandPromptsError,
  ViduExpandPromptsResponse,
  ViduExploreData,
  ViduExploreDetailData,
  ViduExploreDetailError,
  ViduExploreDetailProData,
  ViduExploreDetailProError,
  ViduExploreDetailProResponse,
  ViduExploreDetailResponse,
  ViduExploreError,
  ViduExploreResponse,
  ViduFeedData,
  ViduFeedError,
  ViduFeedListData,
  ViduFeedListError,
  ViduFeedListResponse,
  ViduFeedResponse,
  ViduGetCaseDetailData,
  ViduGetCaseDetailError,
  ViduGetCaseDetailResponse,
  ViduGetCostData,
  ViduGetCostError,
  ViduGetCostResponse,
  ViduGetCreativeData,
  ViduGetCreativeError,
  ViduGetCreativeResponse,
  ViduGetPageConfigData,
  ViduGetPageConfigError,
  ViduGetPageConfigResponse,
  ViduGetPresetPromptData,
  ViduGetPresetPromptError,
  ViduGetPresetPromptResponse,
  ViduGetRegionData,
  ViduGetRegionError,
  ViduGetRegionResponse,
  ViduGetShowCaseData,
  ViduGetShowCaseError,
  ViduGetShowCaseResponse,
  ViduGetUserInviteNotifyData,
  ViduGetUserInviteNotifyError,
  ViduGetUserInviteNotifyResponse,
  ViduGetUserIsFirstSubmitData,
  ViduGetUserIsFirstSubmitError,
  ViduGetUserIsFirstSubmitResponse,
  ViduListCreativesData,
  ViduListCreativesError,
  ViduListCreativesResponse,
  ViduListInspAssetsData,
  ViduListInspAssetsError,
  ViduListInspAssetsResponse,
  ViduListPresetPromptsData,
  ViduListPresetPromptsError,
  ViduListPresetPromptsResponse,
  ViduListSpotlightsData,
  ViduListSpotlightsError,
  ViduListSpotlightsResponse,
  ViduMiniVideoRelativeFeedData,
  ViduMiniVideoRelativeFeedError,
  ViduMiniVideoRelativeFeedResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * get activity template
 */
export const templatesGetActivityTemplate = <ThrowOnError extends boolean = false>(
  options: Options<TemplatesGetActivityTemplateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    TemplatesGetActivityTemplateResponse,
    TemplatesGetActivityTemplateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/activity/template/{activity_id}',
    ...options,
  });
};

export const agentChat = <ThrowOnError extends boolean = false>(options: Options<AgentChatData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<AgentChatResponse, AgentChatError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/chat/{session_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取历史对话接口
 */
export const agentGetChatHistory = <ThrowOnError extends boolean = false>(
  options: Options<AgentGetChatHistoryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<AgentGetChatHistoryResponse, AgentGetChatHistoryError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/chat/{session_id}/history',
    ...options,
  });
};

/**
 * 流式对话接口
 */
export const agentChatStream = <ThrowOnError extends boolean = false>(
  options: Options<AgentChatStreamData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AgentChatStreamResponse, AgentChatStreamError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/chat/{session_id}/stream',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const agentListModels = <ThrowOnError extends boolean = false>(
  options?: Options<AgentListModelsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<AgentListModelsResponse, AgentListModelsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/models',
    ...options,
  });
};

export const agentCreateSession = <ThrowOnError extends boolean = false>(
  options: Options<AgentCreateSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AgentCreateSessionResponse, AgentCreateSessionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const agentDeleteSession = <ThrowOnError extends boolean = false>(
  options: Options<AgentDeleteSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, AgentDeleteSessionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/session/{id}',
    ...options,
  });
};

export const agentRegenerateTts = <ThrowOnError extends boolean = false>(
  options: Options<AgentRegenerateTtsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AgentRegenerateTtsResponse, AgentRegenerateTtsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/tts/regenerate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const agentListVoices = <ThrowOnError extends boolean = false>(
  options?: Options<AgentListVoicesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<AgentListVoicesResponse, AgentListVoicesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/agent/voices',
    ...options,
  });
};

/**
 * app 查询指定版本+渠道是否处于审核模式
 */
export const appReviewGetReviewMode = <ThrowOnError extends boolean = false>(
  options?: Options<AppReviewGetReviewModeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AppReviewGetReviewModeResponse,
    AppReviewGetReviewModeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/app/review-mode',
    ...options,
  });
};

export const appUpgradeGetUpgradeConfig = <ThrowOnError extends boolean = false>(
  options?: Options<AppUpgradeGetUpgradeConfigData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AppUpgradeGetUpgradeConfigResponse,
    AppUpgradeGetUpgradeConfigError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/app/upgrade-config',
    ...options,
  });
};

/**
 * get inspiration assets
 */
export const viduListInspAssets = <ThrowOnError extends boolean = false>(
  options?: Options<ViduListInspAssetsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduListInspAssetsResponse, ViduListInspAssetsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/assets',
    ...options,
  });
};

/**
 * 活动弹幕数据
 */
export const battlesGetActivityBarrage = <ThrowOnError extends boolean = false>(
  options: Options<BattlesGetActivityBarrageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BattlesGetActivityBarrageResponse,
    BattlesGetActivityBarrageError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/battles/barrage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取优秀投稿集锦（按赛道分别展示，点赞数排序）
 */
export const battlesGetExcellentSubmissions = <ThrowOnError extends boolean = false>(
  options?: Options<BattlesGetExcellentSubmissionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    BattlesGetExcellentSubmissionsResponse,
    BattlesGetExcellentSubmissionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/battles/excellent',
    ...options,
  });
};

/**
 * 活动结算
 */
export const battlesActivityResult = <ThrowOnError extends boolean = false>(
  options: Options<BattlesActivityResultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BattlesActivityResultResponse,
    BattlesActivityResultError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/battles/result',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 用户报名活动
 */
export const battlesSignupActivity = <ThrowOnError extends boolean = false>(
  options: Options<BattlesSignupActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, BattlesSignupActivityError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/battles/signup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取统计数据
 */
export const battlesGetStats = <ThrowOnError extends boolean = false>(
  options?: Options<BattlesGetStatsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<BattlesGetStatsResponse, BattlesGetStatsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/battles/stats',
    ...options,
  });
};

/**
 * 获取用户报名信息
 */
export const battlesGetUserSignupInfo = <ThrowOnError extends boolean = false>(
  options?: Options<BattlesGetUserSignupInfoData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    BattlesGetUserSignupInfoResponse,
    BattlesGetUserSignupInfoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/battles/user/signup',
    ...options,
  });
};

export const canvasesCreate = <ThrowOnError extends boolean = false>(
  options: Options<CanvasesCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CanvasesCreateResponse, CanvasesCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/canvas',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const containersOpenStoryboardContainers = <ThrowOnError extends boolean = false>(
  options: Options<ContainersOpenStoryboardContainersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ContainersOpenStoryboardContainersResponse,
    ContainersOpenStoryboardContainersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/canvas/{canvas_id}/video-groups/{video_group_id}/storyboard',
    ...options,
  });
};

export const canvasesGet = <ThrowOnError extends boolean = false>(options: Options<CanvasesGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<CanvasesGetResponse, CanvasesGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/canvas/{id}',
    ...options,
  });
};

/**
 * 按时间线导出
 */
export const clipCompose = <ThrowOnError extends boolean = false>(options: Options<ClipComposeData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ClipComposeResponse, ClipComposeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/compose',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 列出用户的剪辑任务
 */
export const clipListJobs = <ThrowOnError extends boolean = false>(
  options?: Options<ClipListJobsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClipListJobsResponse, ClipListJobsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/jobs',
    ...options,
  });
};

/**
 * 注册媒体资源
 */
export const clipRegisterMedia = <ThrowOnError extends boolean = false>(
  options: Options<ClipRegisterMediaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClipRegisterMediaResponse, ClipRegisterMediaError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/medias',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 列出用户的剪辑项目
 */
export const clipListProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ClipListProjectsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ClipListProjectsResponse, ClipListProjectsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects',
    ...options,
  });
};

/**
 * 创建剪辑项目
 */
export const clipCreateProject = <ThrowOnError extends boolean = false>(
  options: Options<ClipCreateProjectData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClipCreateProjectResponse, ClipCreateProjectError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 根据任务ID获取剪辑项目
 */
export const clipGetProjectByTaskId = <ThrowOnError extends boolean = false>(
  options: Options<ClipGetProjectByTaskIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ClipGetProjectByTaskIdResponse,
    ClipGetProjectByTaskIdError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects/task/{task_id}',
    ...options,
  });
};

/**
 * 删除剪辑项目
 */
export const clipDeleteProject = <ThrowOnError extends boolean = false>(
  options: Options<ClipDeleteProjectData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ClipDeleteProjectError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects/{id}',
    ...options,
  });
};

/**
 * 获取剪辑项目
 */
export const clipGetProject = <ThrowOnError extends boolean = false>(
  options: Options<ClipGetProjectData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ClipGetProjectResponse, ClipGetProjectError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects/{id}',
    ...options,
  });
};

/**
 * 更新剪辑项目
 */
export const clipUpdateProject = <ThrowOnError extends boolean = false>(
  options: Options<ClipUpdateProjectData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ClipUpdateProjectResponse, ClipUpdateProjectError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects/{project.id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const clipSaveAndExport = <ThrowOnError extends boolean = false>(
  options: Options<ClipSaveAndExportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClipSaveAndExportResponse, ClipSaveAndExportError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects/{project.id}/save-and-export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 按项目导出
 */
export const clipExportByProject = <ThrowOnError extends boolean = false>(
  options: Options<ClipExportByProjectData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ClipExportByProjectResponse, ClipExportByProjectError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/clip/projects/{project_id}/export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const containersList = <ThrowOnError extends boolean = false>(
  options?: Options<ContainersListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ContainersListResponse, ContainersListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers',
    ...options,
  });
};

export const containersMergeClips = <ThrowOnError extends boolean = false>(
  options: Options<ContainersMergeClipsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ContainersMergeClipsResponse, ContainersMergeClipsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers/merge-clips',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const containersRandomMusic = <ThrowOnError extends boolean = false>(
  options: Options<ContainersRandomMusicData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ContainersRandomMusicResponse,
    ContainersRandomMusicError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers/random-music',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const containersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContainersUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ContainersUpdateResponse, ContainersUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const containersAction = <ThrowOnError extends boolean = false>(
  options: Options<ContainersActionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ContainersActionResponse, ContainersActionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers/{id}/action',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const containersGetShareDetail = <ThrowOnError extends boolean = false>(
  options: Options<ContainersGetShareDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ContainersGetShareDetailResponse,
    ContainersGetShareDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers/{id}/share',
    ...options,
  });
};

export const containersGetShareToken = <ThrowOnError extends boolean = false>(
  options: Options<ContainersGetShareTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ContainersGetShareTokenResponse,
    ContainersGetShareTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/containers/{id}/share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取计价
 */
export const viduGetCost = <ThrowOnError extends boolean = false>(options?: Options<ViduGetCostData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ViduGetCostResponse, ViduGetCostError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/cost',
    ...options,
  });
};

export const creationsBatchDelete = <ThrowOnError extends boolean = false>(
  options: Options<CreationsBatchDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, CreationsBatchDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creations/batch/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const creationsBatchGetWatermarkResource = <ThrowOnError extends boolean = false>(
  options: Options<CreationsBatchGetWatermarkResourceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreationsBatchGetWatermarkResourceResponse,
    CreationsBatchGetWatermarkResourceError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creations/batch/watermark',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const creationsDelete = <ThrowOnError extends boolean = false>(
  options: Options<CreationsDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, CreationsDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creations/{id}',
    ...options,
  });
};

export const creationsDetail = <ThrowOnError extends boolean = false>(
  options: Options<CreationsDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<CreationsDetailResponse, CreationsDetailError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creations/{id}/detail',
    ...options,
  });
};

export const creationsGetShareDetail = <ThrowOnError extends boolean = false>(
  options: Options<CreationsGetShareDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CreationsGetShareDetailResponse,
    CreationsGetShareDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creations/{id}/share',
    ...options,
  });
};

export const creationsGetShareToken = <ThrowOnError extends boolean = false>(
  options: Options<CreationsGetShareTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    CreationsGetShareTokenResponse,
    CreationsGetShareTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creations/{id}/share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * get Creatives Partner Program config
 */
export const viduListCreatives = <ThrowOnError extends boolean = false>(
  options?: Options<ViduListCreativesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduListCreativesResponse, ViduListCreativesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creatives',
    ...options,
  });
};

export const viduGetCreative = <ThrowOnError extends boolean = false>(
  options: Options<ViduGetCreativeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ViduGetCreativeResponse, ViduGetCreativeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/creatives/{id}',
    ...options,
  });
};

/**
 * module, function, name, type, value
 */
export const customizeAdd = <ThrowOnError extends boolean = false>(
  options: Options<CustomizeAddData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CustomizeAddResponse, CustomizeAddError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/customize/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const customizeDelete = <ThrowOnError extends boolean = false>(
  options?: Options<CustomizeDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<unknown, CustomizeDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/customize/delete',
    ...options,
  });
};

export const customizeGet = <ThrowOnError extends boolean = false>(
  options?: Options<CustomizeGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CustomizeGetResponse, CustomizeGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/customize/get',
    ...options,
  });
};

export const customizeRemove = <ThrowOnError extends boolean = false>(
  options?: Options<CustomizeRemoveData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<CustomizeRemoveResponse, CustomizeRemoveError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/customize/remove',
    ...options,
  });
};

export const customizeSet = <ThrowOnError extends boolean = false>(
  options: Options<CustomizeSetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CustomizeSetResponse, CustomizeSetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/customize/set',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const viduExplore = <ThrowOnError extends boolean = false>(options?: Options<ViduExploreData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ViduExploreResponse, ViduExploreError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/explore',
    ...options,
  });
};

export const viduExploreDetailPro = <ThrowOnError extends boolean = false>(
  options: Options<ViduExploreDetailProData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ViduExploreDetailProResponse, ViduExploreDetailProError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/explore/pro/{id}',
    ...options,
  });
};

export const viduExploreDetail = <ThrowOnError extends boolean = false>(
  options: Options<ViduExploreDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ViduExploreDetailResponse, ViduExploreDetailError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/explore/{id}',
    ...options,
  });
};

export const viduFeed = <ThrowOnError extends boolean = false>(options?: Options<ViduFeedData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ViduFeedResponse, ViduFeedError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/feed',
    ...options,
  });
};

/**
 * 重构
 */
export const viduFeedList = <ThrowOnError extends boolean = false>(
  options?: Options<ViduFeedListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduFeedListResponse, ViduFeedListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/feed/list',
    ...options,
  });
};

export const inspirationsGetLikeInspirations = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetLikeInspirationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetLikeInspirationsResponse,
    InspirationsGetLikeInspirationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/like',
    ...options,
  });
};

export const inspirationsGetLikeInspirationsList = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetLikeInspirationsListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetLikeInspirationsListResponse,
    InspirationsGetLikeInspirationsListError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/like/list',
    ...options,
  });
};

/**
 * Create media asset
 */
export const inspirationsCreateMediaAsset = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsCreateMediaAssetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InspirationsCreateMediaAssetResponse,
    InspirationsCreateMediaAssetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/media-assets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * List media assets
 */
export const inspirationsMediaAssetFeed = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsMediaAssetFeedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsMediaAssetFeedResponse,
    InspirationsMediaAssetFeedError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/media-assets/feed',
    ...options,
  });
};

/**
 * Create mini video
 */
export const inspirationsCreateMiniVideo = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsCreateMiniVideoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InspirationsCreateMiniVideoResponse,
    InspirationsCreateMiniVideoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/mini-videos',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const inspirationsGetMyInspirations = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetMyInspirationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetMyInspirationsResponse,
    InspirationsGetMyInspirationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/my',
    ...options,
  });
};

export const inspirationsGetCollectInspirations = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetCollectInspirationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetCollectInspirationsResponse,
    InspirationsGetCollectInspirationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/my/collect',
    ...options,
  });
};

export const inspirationsGetCollectInspirationsList = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetCollectInspirationsListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetCollectInspirationsListResponse,
    InspirationsGetCollectInspirationsListError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/my/collect/list',
    ...options,
  });
};

export const inspirationsGetMyInspirationsList = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetMyInspirationsListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetMyInspirationsListResponse,
    InspirationsGetMyInspirationsListError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/my/list',
    ...options,
  });
};

export const inspirationsGetPersonaInspirationsList = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsGetPersonaInspirationsListData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    InspirationsGetPersonaInspirationsListResponse,
    InspirationsGetPersonaInspirationsListError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/persona/list/{user_id}',
    ...options,
  });
};

/**
 * *************************************客态接口********************************************
 */
export const inspirationsGetPersonaInspirations = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsGetPersonaInspirationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    InspirationsGetPersonaInspirationsResponse,
    InspirationsGetPersonaInspirationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/persona/{user_id}',
    ...options,
  });
};

export const inspirationsGetInspirationIdsForSeo = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsGetInspirationIdsForSeoData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsGetInspirationIdsForSeoResponse,
    InspirationsGetInspirationIdsForSeoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/seo',
    ...options,
  });
};

/**
 * Create short film
 */
export const inspirationsCreateShortFilm = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsCreateShortFilmData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InspirationsCreateShortFilmResponse,
    InspirationsCreateShortFilmError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/short-films',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * List inspirations
 */
export const inspirationsShortFilmFeed = <ThrowOnError extends boolean = false>(
  options?: Options<InspirationsShortFilmFeedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    InspirationsShortFilmFeedResponse,
    InspirationsShortFilmFeedError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/short-films/feed',
    ...options,
  });
};

/**
 * detail 前端改造量很大，继续用老的结构
 */
export const inspirationsGetInspirationDetail = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsGetInspirationDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    InspirationsGetInspirationDetailResponse,
    InspirationsGetInspirationDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/{id}',
    ...options,
  });
};

export const inspirationsGetInspirationShareDetail = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsGetInspirationShareDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    InspirationsGetInspirationShareDetailResponse,
    InspirationsGetInspirationShareDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/{id}/share',
    ...options,
  });
};

export const inspirationsGetInspirationShareToken = <ThrowOnError extends boolean = false>(
  options: Options<InspirationsGetInspirationShareTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    InspirationsGetInspirationShareTokenResponse,
    InspirationsGetInspirationShareTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/inspirations/{id}/share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const notificationsInteractionList = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationsInteractionListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    NotificationsInteractionListResponse,
    NotificationsInteractionListError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/interaction/notifications',
    ...options,
  });
};

/**
 * 废弃功能，切换新接口
 */
export const materialsListElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsListElementsResponse,
    MaterialsListElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements',
    ...options,
  });
};

export const materialsCreateElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCreateElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsCreateElementResponse,
    MaterialsCreateElementError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const materialsBatchGetElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsBatchGetElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsBatchGetElementsResponse,
    MaterialsBatchGetElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/batch',
    ...options,
  });
};

/**
 * create element
 */
export const materialsCreateElementCheck = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsCreateElementCheckData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsCreateElementCheckResponse,
    MaterialsCreateElementCheckError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/create/check',
    ...options,
  });
};

/**
 * 通过 Prompt 文生图异步创建 Element
 */
export const materialsCreateElementTask = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCreateElementTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsCreateElementTaskResponse,
    MaterialsCreateElementTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/create_task',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取元素关联的创作列表
 */
export const materialsGetElementCreations = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetElementCreationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetElementCreationsResponse,
    MaterialsGetElementCreationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/creations',
    ...options,
  });
};

/**
 * batch delete elements
 */
export const materialsBatchDeleteElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsBatchDeleteElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, MaterialsBatchDeleteElementError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/delete/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const materialsGetElementDetail = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsGetElementDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    MaterialsGetElementDetailResponse,
    MaterialsGetElementDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/detail/{id}',
    ...options,
  });
};

export const materialsBatchHistoryElements = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsBatchHistoryElementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsBatchHistoryElementsResponse,
    MaterialsBatchHistoryElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/history',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const materialsGetHistoryElementDetail = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetHistoryElementDetailData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetHistoryElementDetailResponse,
    MaterialsGetHistoryElementDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/history/detail',
    ...options,
  });
};

/**
 * 废弃功能，切换过程需要保留
 */
export const materialsGetMyElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetMyElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetMyElementsResponse,
    MaterialsGetMyElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/my',
    ...options,
  });
};

/**
 * 代替 GetMyElements
 */
export const materialsGetMyElementsV2 = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetMyElementsV2Data, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetMyElementsV2Response,
    MaterialsGetMyElementsV2Error,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/my2',
    ...options,
  });
};

/**
 * 代替 ListElements
 */
export const materialsListPersonalElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListPersonalElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsListPersonalElementsResponse,
    MaterialsListPersonalElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/personal',
    ...options,
  });
};

/**
 * pre process element
 */
export const materialsPreProcessElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsPreProcessElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsPreProcessElementResponse,
    MaterialsPreProcessElementError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/pre-process',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 列表推荐主体: 优先返回个人主体（不超过2）；不足时用热门主体补齐，剩余继续返回热门主体
 */
export const materialsListRecommendElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListRecommendElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsListRecommendElementsResponse,
    MaterialsListRecommendElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/recommend',
    ...options,
  });
};

/**
 * 查询主体创作任务状态（?task_id=xxx）
 */
export const materialsGetElementTaskState = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetElementTaskStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetElementTaskStateResponse,
    MaterialsGetElementTaskStateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/state',
    ...options,
  });
};

/**
 * 按任务维度列出当前用户的主体创作历史任务
 */
export const materialsListElementTaskHistory = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListElementTaskHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsListElementTaskHistoryResponse,
    MaterialsListElementTaskHistoryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/tasks/history',
    ...options,
  });
};

export const materialsUpdateElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsUpdateElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    MaterialsUpdateElementResponse,
    MaterialsUpdateElementError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/{element.id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const materialsDeleteElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsDeleteElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, MaterialsDeleteElementError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/{id}',
    ...options,
  });
};

/**
 * 一期的接口还在用，目前只在创作的时候，验证element是否可用，详情用GetElementDetail
 */
export const materialsGetElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsGetElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<MaterialsGetElementResponse, MaterialsGetElementError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/{id}',
    ...options,
  });
};

/**
 * 取消主体创作任务
 */
export const materialsCancelElementTask = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCancelElementTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, MaterialsCancelElementTaskError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/elements/{task_id}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const materialsListLabels = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListLabelsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<MaterialsListLabelsResponse, MaterialsListLabelsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/labels',
    ...options,
  });
};

export const materialsCreateLabel = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCreateLabelData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<MaterialsCreateLabelResponse, MaterialsCreateLabelError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/labels',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const materialsDeleteLabel = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsDeleteLabelData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, MaterialsDeleteLabelError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/labels/{id}',
    ...options,
  });
};

/**
 * 查询我的动作列表
 */
export const materialsListMotions = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListMotionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<MaterialsListMotionsResponse, MaterialsListMotionsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/motions',
    ...options,
  });
};

/**
 * ===== 动作相关接口 =====
 * 创建我的动作
 */
export const materialsCreateMotion = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCreateMotionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsCreateMotionResponse,
    MaterialsCreateMotionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/motions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 删除我的动作
 */
export const materialsDeleteMotion = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsDeleteMotionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, MaterialsDeleteMotionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/motions/{id}',
    ...options,
  });
};

/**
 * 查询我的动作详情
 */
export const materialsGetMotion = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsGetMotionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<MaterialsGetMotionResponse, MaterialsGetMotionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/motions/{id}',
    ...options,
  });
};

/**
 * 修改我的动作名称
 */
export const materialsUpdateMotion = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsUpdateMotionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<MaterialsUpdateMotionResponse, MaterialsUpdateMotionError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/vidu/v1/material/motions/{motion.id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

/**
 * 获取当前排行榜
 */
export const materialsGetRanking = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetRankingData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<MaterialsGetRankingResponse, MaterialsGetRankingError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/ranking',
    ...options,
  });
};

/**
 * 领取奖励
 */
export const materialsClaimReward = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsClaimRewardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<MaterialsClaimRewardResponse, MaterialsClaimRewardError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/ranking/claim_reward',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 查询激励
 */
export const materialsUnclaimedReward = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsUnclaimedRewardData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsUnclaimedRewardResponse,
    MaterialsUnclaimedRewardError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/ranking/unclaimed_reward',
    ...options,
  });
};

/**
 * 获取共享主体类别列表
 */
export const materialsGetShareCategories = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetShareCategoriesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetShareCategoriesResponse,
    MaterialsGetShareCategoriesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/categories',
    ...options,
  });
};

/**
 * 列出共享库元素
 */
export const materialsShareElementsFeed = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsShareElementsFeedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsShareElementsFeedResponse,
    MaterialsShareElementsFeedError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/feed',
    ...options,
  });
};

export const materialsGetLastReviewedShareElement = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetLastReviewedShareElementData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetLastReviewedShareElementResponse,
    MaterialsGetLastReviewedShareElementError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/last_reviewed',
    ...options,
  });
};

/**
 * 获取共享主体类别列表
 */
export const materialsGetMyShareElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetMyShareElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetMyShareElementsResponse,
    MaterialsGetMyShareElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/my',
    ...options,
  });
};

/**
 * 获取客态共享主体
 */
export const materialsGetPersonaShareElements = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsGetPersonaShareElementsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    MaterialsGetPersonaShareElementsResponse,
    MaterialsGetPersonaShareElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/persona/{user_id}',
    ...options,
  });
};

/**
 * 列表热门主体: 按使用次数排序
 */
export const materialsListPopularElements = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListPopularElementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsListPopularElementsResponse,
    MaterialsListPopularElementsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/popular',
    ...options,
  });
};

/**
 * 提交元素到共享库
 */
export const materialsSubmitShareElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsSubmitShareElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsSubmitShareElementResponse,
    MaterialsSubmitShareElementError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/submit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 取消共享
 */
export const materialsCancelShareElement = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCancelShareElementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, MaterialsCancelShareElementError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/{share_id}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 从共享库复制到个人库
 */
export const materialsCopyFromShare = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCopyFromShareData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MaterialsCopyFromShareResponse,
    MaterialsCopyFromShareError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/material/share_elements/{share_id}/copy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const viduMiniVideoRelativeFeed = <ThrowOnError extends boolean = false>(
  options?: Options<ViduMiniVideoRelativeFeedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ViduMiniVideoRelativeFeedResponse,
    ViduMiniVideoRelativeFeedError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/mini-video/relative',
    ...options,
  });
};

/**
 * 广告观看事件回传，供看广告得积分/去水印等场景使用
 */
export const missionCenterReportAdEvent = <ThrowOnError extends boolean = false>(
  options: Options<MissionCenterReportAdEventData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MissionCenterReportAdEventResponse,
    MissionCenterReportAdEventError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/missions/ad-event',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 查询任务限额
 */
export const missionCenterGetMissionQuota = <ThrowOnError extends boolean = false>(
  options?: Options<MissionCenterGetMissionQuotaData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MissionCenterGetMissionQuotaResponse,
    MissionCenterGetMissionQuotaError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/missions/quota',
    ...options,
  });
};

export const creationsGetMy = <ThrowOnError extends boolean = false>(
  options?: Options<CreationsGetMyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<CreationsGetMyResponse, CreationsGetMyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/my-creations',
    ...options,
  });
};

export const offlineAvatarsListUserOfflineAvatars = <ThrowOnError extends boolean = false>(
  options?: Options<OfflineAvatarsListUserOfflineAvatarsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OfflineAvatarsListUserOfflineAvatarsResponse,
    OfflineAvatarsListUserOfflineAvatarsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/offline-avatars',
    ...options,
  });
};

export const offlineAvatarsCreateUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsCreateUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OfflineAvatarsCreateUserOfflineAvatarResponse,
    OfflineAvatarsCreateUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/offline-avatars',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const offlineAvatarsCheckCreateUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options?: Options<OfflineAvatarsCheckCreateUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OfflineAvatarsCheckCreateUserOfflineAvatarResponse,
    OfflineAvatarsCheckCreateUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/offline-avatars/create/check',
    ...options,
  });
};

export const offlineAvatarsDeleteUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsDeleteUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, OfflineAvatarsDeleteUserOfflineAvatarError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/offline-avatars/{id}',
    ...options,
  });
};

export const offlineAvatarsGetUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsGetUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OfflineAvatarsGetUserOfflineAvatarResponse,
    OfflineAvatarsGetUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/offline-avatars/{id}',
    ...options,
  });
};

export const offlineAvatarsUpdateUserOfflineAvatar = <ThrowOnError extends boolean = false>(
  options: Options<OfflineAvatarsUpdateUserOfflineAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    OfflineAvatarsUpdateUserOfflineAvatarResponse,
    OfflineAvatarsUpdateUserOfflineAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/offline-avatars/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * get page configs by page keys, e.g. get template entrance label uri by "template_entrance_label"
 */
export const viduGetPageConfig = <ThrowOnError extends boolean = false>(
  options?: Options<ViduGetPageConfigData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduGetPageConfigResponse, ViduGetPageConfigError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/page-config',
    ...options,
  });
};

/**
 * 列表预置 提示词
 */
export const viduListPresetPrompts = <ThrowOnError extends boolean = false>(
  options?: Options<ViduListPresetPromptsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ViduListPresetPromptsResponse,
    ViduListPresetPromptsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/preset-prompts',
    ...options,
  });
};

/**
 * 列表预置 提示词
 */
export const viduGetPresetPrompt = <ThrowOnError extends boolean = false>(
  options: Options<ViduGetPresetPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ViduGetPresetPromptResponse, ViduGetPresetPromptError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/preset-prompts/{id}',
    ...options,
  });
};

export const projectsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ProjectsCreateResponse, ProjectsCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const projectsUseShowCase = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsUseShowCaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ProjectsUseShowCaseResponse, ProjectsUseShowCaseError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects/clone',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const projectsGetMy = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectsGetMyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ProjectsGetMyResponse, ProjectsGetMyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects/me',
    ...options,
  });
};

export const projectsListShowCase = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectsListShowCaseData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ProjectsListShowCaseResponse, ProjectsListShowCaseError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects/showcase',
    ...options,
  });
};

export const projectsGetViralGrowthInfo = <ThrowOnError extends boolean = false>(
  options?: Options<ProjectsGetViralGrowthInfoData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ProjectsGetViralGrowthInfoResponse,
    ProjectsGetViralGrowthInfoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects/viral/growth/info',
    ...options,
  });
};

export const projectsGet = <ThrowOnError extends boolean = false>(options: Options<ProjectsGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ProjectsGetResponse, ProjectsGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects/{id}',
    ...options,
  });
};

export const projectsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ProjectsUpdateResponse, ProjectsUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/projects/{project.id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 扩展提示词
 */
export const viduExpandPrompts = <ThrowOnError extends boolean = false>(
  options: Options<ViduExpandPromptsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ViduExpandPromptsResponse, ViduExpandPromptsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/prompts/expand',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const viduGetRegion = <ThrowOnError extends boolean = false>(
  options?: Options<ViduGetRegionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduGetRegionResponse, ViduGetRegionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/region',
    ...options,
  });
};

/**
 * gen data by sharing channel
 */
export const sharingGetShareData = <ThrowOnError extends boolean = false>(
  options: Options<SharingGetShareDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<SharingGetShareDataResponse, SharingGetShareDataError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/share/data/{channel}',
    ...options,
  });
};

/**
 * get sharing options
 */
export const sharingGetShareOptions = <ThrowOnError extends boolean = false>(
  options?: Options<SharingGetShareOptionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SharingGetShareOptionsResponse,
    SharingGetShareOptionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/share/options',
    ...options,
  });
};

/**
 * 获取用户分享裂变挑战（没有限时挑战时启动限时挑战）
 */
export const sharingGetUserShareViralChlg = <ThrowOnError extends boolean = false>(
  options?: Options<SharingGetUserShareViralChlgData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SharingGetUserShareViralChlgResponse,
    SharingGetUserShareViralChlgError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/share/viral/chlg',
    ...options,
  });
};

/**
 * 获取微信鉴权
 */
export const sharingGetWechatSignature = <ThrowOnError extends boolean = false>(
  options?: Options<SharingGetWechatSignatureData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SharingGetWechatSignatureResponse,
    SharingGetWechatSignatureError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/share/wechat/signature',
    ...options,
  });
};

/**
 * show short films and templates, asset cant show because of pagination
 */
export const viduGetShowCase = <ThrowOnError extends boolean = false>(
  options?: Options<ViduGetShowCaseData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduGetShowCaseResponse, ViduGetShowCaseError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/showcase',
    ...options,
  });
};

/**
 * get case detail by id/scene
 */
export const viduGetCaseDetail = <ThrowOnError extends boolean = false>(
  options?: Options<ViduGetCaseDetailData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduGetCaseDetailResponse, ViduGetCaseDetailError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/showcase/detail',
    ...options,
  });
};

/**
 * 获取资源位
 */
export const viduListSpotlights = <ThrowOnError extends boolean = false>(
  options?: Options<ViduListSpotlightsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ViduListSpotlightsResponse, ViduListSpotlightsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/spotlights',
    ...options,
  });
};

/**
 * 获取广场信息，大接口，包含各种信息
 */
export const squareGetSquareContent = <ThrowOnError extends boolean = false>(
  options?: Options<SquareGetSquareContentData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SquareGetSquareContentResponse,
    SquareGetSquareContentError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/square/content',
    ...options,
  });
};

export const squareGetThemedEventPopup = <ThrowOnError extends boolean = false>(
  options?: Options<SquareGetThemedEventPopupData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SquareGetThemedEventPopupResponse,
    SquareGetThemedEventPopupError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/square/themed-events/popup',
    ...options,
  });
};

/**
 * 获取主题活动信息
 */
export const squareGetThemedEvent = <ThrowOnError extends boolean = false>(
  options: Options<SquareGetThemedEventData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<SquareGetThemedEventResponse, SquareGetThemedEventError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/square/themed-events/{id}',
    ...options,
  });
};

/**
 * 获取主题活动落地页信息
 */
export const squareThemedEventLanding = <ThrowOnError extends boolean = false>(
  options: Options<SquareThemedEventLandingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SquareThemedEventLandingResponse,
    SquareThemedEventLandingError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/square/themed-events/{id}/landing',
    ...options,
  });
};

/**
 * 获取当前用户可见的通知列表
 */
export const notificationsListSysNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationsListSysNotificationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    NotificationsListSysNotificationsResponse,
    NotificationsListSysNotificationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/system/notifications',
    ...options,
  });
};

/**
 * 标记该用户已读通知
 */
export const notificationsReadSysNotifications = <ThrowOnError extends boolean = false>(
  options: Options<NotificationsReadSysNotificationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, NotificationsReadSysNotificationsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/system/notifications/read',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const notificationsGetUnreadCount = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationsGetUnreadCountData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    NotificationsGetUnreadCountResponse,
    NotificationsGetUnreadCountError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/system/notifications/unread-count',
    ...options,
  });
};

/**
 * 获取当前用户可见的通知详情
 */
export const notificationsGetSysNotification = <ThrowOnError extends boolean = false>(
  options: Options<NotificationsGetSysNotificationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    NotificationsGetSysNotificationResponse,
    NotificationsGetSysNotificationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/system/notifications/{id}',
    ...options,
  });
};

export const tasksCreate = <ThrowOnError extends boolean = false>(options: Options<TasksCreateData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<TasksCreateResponse, TasksCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksGetCostConfig = <ThrowOnError extends boolean = false>(
  options?: Options<TasksGetCostConfigData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksGetCostConfigResponse, TasksGetCostConfigError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/cost-config',
    ...options,
  });
};

export const tasksCount = <ThrowOnError extends boolean = false>(options?: Options<TasksCountData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<TasksCountResponse, TasksCountError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/count',
    ...options,
  });
};

/**
 * create task by craft(template or inspiration)
 */
export const tasksCreateByCraft = <ThrowOnError extends boolean = false>(
  options: Options<TasksCreateByCraftData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TasksCreateByCraftResponse, TasksCreateByCraftError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/craft',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取任务所需的 credits
 */
export const tasksGetTaskCredits = <ThrowOnError extends boolean = false>(
  options?: Options<TasksGetTaskCreditsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksGetTaskCreditsResponse, TasksGetTaskCreditsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/credits',
    ...options,
  });
};

export const tasksGetMyTaskHistory = <ThrowOnError extends boolean = false>(
  options?: Options<TasksGetMyTaskHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    TasksGetMyTaskHistoryResponse,
    TasksGetMyTaskHistoryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/history/me',
    ...options,
  });
};

/**
 * 最小化创作入口：通用创作/二次创作合并，参数最小化
 */
export const tasksMiniCreate = <ThrowOnError extends boolean = false>(
  options: Options<TasksMiniCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TasksMiniCreateResponse, TasksMiniCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/mini',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksGetUserQuota = <ThrowOnError extends boolean = false>(
  options?: Options<TasksGetUserQuotaData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksGetUserQuotaResponse, TasksGetUserQuotaError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/quota',
    ...options,
  });
};

export const tasksRecaption = <ThrowOnError extends boolean = false>(
  options: Options<TasksRecaptionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TasksRecaptionResponse, TasksRecaptionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/recaption',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取风格转绘列表
 */
export const tasksListRemixStyles = <ThrowOnError extends boolean = false>(
  options?: Options<TasksListRemixStylesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksListRemixStylesResponse, TasksListRemixStylesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/remix-styles',
    ...options,
  });
};

export const tasksGetState = <ThrowOnError extends boolean = false>(
  options?: Options<TasksGetStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksGetStateResponse, TasksGetStateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/state',
    ...options,
  });
};

export const tasksGetTeamQuota = <ThrowOnError extends boolean = false>(
  options?: Options<TasksGetTeamQuotaData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TasksGetTeamQuotaResponse, TasksGetTeamQuotaError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/team-quota',
    ...options,
  });
};

/**
 * 统一的 AI 工具调用接口
 */
export const tasksCreateByTool = <ThrowOnError extends boolean = false>(
  options: Options<TasksCreateByToolData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TasksCreateByToolResponse, TasksCreateByToolError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/tool',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tasksDelete = <ThrowOnError extends boolean = false>(options: Options<TasksDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<unknown, TasksDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/{id}',
    ...options,
  });
};

export const tasksGet = <ThrowOnError extends boolean = false>(options: Options<TasksGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<TasksGetResponse, TasksGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/{id}',
    ...options,
  });
};

export const tasksCancel = <ThrowOnError extends boolean = false>(options: Options<TasksCancelData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<unknown, TasksCancelError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/tasks/{id}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * list templates
 */
export const templatesList = <ThrowOnError extends boolean = false>(
  options?: Options<TemplatesListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TemplatesListResponse, TemplatesListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/templates',
    ...options,
  });
};

/**
 * list template categories
 */
export const templatesListCategories = <ThrowOnError extends boolean = false>(
  options?: Options<TemplatesListCategoriesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    TemplatesListCategoriesResponse,
    TemplatesListCategoriesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/templates/categories',
    ...options,
  });
};

/**
 * list event templates: 按事件 key 返回一组固定模版（配置在 vidu yaml）
 * 调用方需登录；事件配置 required_tag 非空时，user.tags 须包含该 tag，否则 404
 */
export const templatesListEventTemplates = <ThrowOnError extends boolean = false>(
  options: Options<TemplatesListEventTemplatesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    TemplatesListEventTemplatesResponse,
    TemplatesListEventTemplatesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/templates/events/{event_key}',
    ...options,
  });
};

/**
 * list template groups
 */
export const templatesListTemplateGroups = <ThrowOnError extends boolean = false>(
  options?: Options<TemplatesListTemplateGroupsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    TemplatesListTemplateGroupsResponse,
    TemplatesListTemplateGroupsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/templates/groups',
    ...options,
  });
};

/**
 * get template by id
 */
export const templatesGet = <ThrowOnError extends boolean = false>(
  options: Options<TemplatesGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<TemplatesGetResponse, TemplatesGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/templates/{scene}',
    ...options,
  });
};

/**
 * 获取用户邀请信息
 */
export const viduGetUserInviteNotify = <ThrowOnError extends boolean = false>(
  options?: Options<ViduGetUserInviteNotifyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ViduGetUserInviteNotifyResponse,
    ViduGetUserInviteNotifyError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/user/invite/notify',
    ...options,
  });
};

/**
 * 获取用户是否是首次投稿
 */
export const viduGetUserIsFirstSubmit = <ThrowOnError extends boolean = false>(
  options?: Options<ViduGetUserIsFirstSubmitData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ViduGetUserIsFirstSubmitResponse,
    ViduGetUserIsFirstSubmitError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/user/is-first-submit',
    ...options,
  });
};

export const usersGetMyFollowers = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetMyFollowersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetMyFollowersResponse, UsersGetMyFollowersError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/user/my/followers',
    ...options,
  });
};

export const usersGetMyFollowings = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetMyFollowingsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetMyFollowingsResponse, UsersGetMyFollowingsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/user/my/followings',
    ...options,
  });
};

export const usersGetMyStat = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetMyStatData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetMyStatResponse, UsersGetMyStatError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/user/my/stat',
    ...options,
  });
};

/**
 * *************************************个人客态接口********************************************
 */
export const usersGetPersona = <ThrowOnError extends boolean = false>(
  options: Options<UsersGetPersonaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<UsersGetPersonaResponse, UsersGetPersonaError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/user/persona/{user_id}',
    ...options,
  });
};

/**
 * 获取活动列表
 */
export const activitiesListActivities = <ThrowOnError extends boolean = false>(
  options?: Options<ActivitiesListActivitiesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ActivitiesListActivitiesResponse,
    ActivitiesListActivitiesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities',
    ...options,
  });
};

export const activitiesActivitityFeed = <ThrowOnError extends boolean = false>(
  options?: Options<ActivitiesActivitityFeedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ActivitiesActivitityFeedResponse,
    ActivitiesActivitityFeedError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/feed',
    ...options,
  });
};

/**
 * 查看作品列表
 */
export const activitiesListWorks = <ThrowOnError extends boolean = false>(
  options?: Options<ActivitiesListWorksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ActivitiesListWorksResponse, ActivitiesListWorksError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/works',
    ...options,
  });
};

/**
 * 提交投稿
 */
export const activitiesSubmitWork = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesSubmitWorkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ActivitiesSubmitWorkResponse, ActivitiesSubmitWorkError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/works',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取作品详情
 */
export const activitiesGetWork = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesGetWorkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ActivitiesGetWorkResponse, ActivitiesGetWorkError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/works/{id}',
    ...options,
  });
};

/**
 * 取消点赞
 */
export const activitiesCancelLikeWork = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesCancelLikeWorkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ActivitiesCancelLikeWorkError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/works/{work_id}',
    ...options,
  });
};

/**
 * 点赞
 */
export const activitiesLikeWork = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesLikeWorkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, ActivitiesLikeWorkError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/works/{work_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 报名活动
 */
export const activitiesSignupActivity = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesSignupActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, ActivitiesSignupActivityError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/activities/{activity_id}/signup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取活动 详情
 */
export const activitiesGetActivity = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesGetActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ActivitiesGetActivityResponse, ActivitiesGetActivityError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/vidu/v1/vidu/activities/{id}',
      ...options,
    },
  );
};

/**
 * 获取活动详情
 */
export const activitiesGetCampaign = <ThrowOnError extends boolean = false>(
  options: Options<ActivitiesGetCampaignData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ActivitiesGetCampaignResponse, ActivitiesGetCampaignError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/vidu/v1/vidu/campaigns/{id}',
      ...options,
    },
  );
};

/**
 * 获取 Earn 活动列表
 */
export const earnListEarnActivities = <ThrowOnError extends boolean = false>(
  options?: Options<EarnListEarnActivitiesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    EarnListEarnActivitiesResponse,
    EarnListEarnActivitiesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/activities',
    ...options,
  });
};

/**
 * 获取 Earn 活动详情
 */
export const earnGetActivity = <ThrowOnError extends boolean = false>(
  options: Options<EarnGetActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<EarnGetActivityResponse, EarnGetActivityError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/activities/{id}',
    ...options,
  });
};

/**
 * 提交 Earn 外链作品
 */
export const earnSubmitWork = <ThrowOnError extends boolean = false>(
  options: Options<EarnSubmitWorkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<EarnSubmitWorkResponse, EarnSubmitWorkError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/activities/{target_id}/submits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 提交或重新提交创作者申请
 */
export const earnSubmitApply = <ThrowOnError extends boolean = false>(
  options: Options<EarnSubmitApplyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<EarnSubmitApplyResponse, EarnSubmitApplyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/apply',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Campion列表
 */
export const earnListCampions = <ThrowOnError extends boolean = false>(
  options?: Options<EarnListCampionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<EarnListCampionsResponse, EarnListCampionsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/campions',
    ...options,
  });
};

/**
 * 获取当前用户创作者申请
 */
export const earnGetMy = <ThrowOnError extends boolean = false>(options?: Options<EarnGetMyData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<EarnGetMyResponse, EarnGetMyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/my',
    ...options,
  });
};

/**
 * 我的 Earn 投稿记录
 */
export const earnListMySubmits = <ThrowOnError extends boolean = false>(
  options?: Options<EarnListMySubmitsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<EarnListMySubmitsResponse, EarnListMySubmitsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/submits',
    ...options,
  });
};

/**
 * 我的提现/提取记录
 */
export const earnListMyWithdraws = <ThrowOnError extends boolean = false>(
  options?: Options<EarnListMyWithdrawsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<EarnListMyWithdrawsResponse, EarnListMyWithdrawsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/withdraws',
    ...options,
  });
};

/**
 * 发起积分提取或现金提现
 */
export const earnCreateWithdraw = <ThrowOnError extends boolean = false>(
  options: Options<EarnCreateWithdrawData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<EarnCreateWithdrawResponse, EarnCreateWithdrawError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/vidu/earn/withdraws',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 列出用户音色
 */
export const materialsListVoices = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListVoicesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<MaterialsListVoicesResponse, MaterialsListVoicesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/voices',
    ...options,
  });
};

/**
 * 创建音色，返回 voice_id
 */
export const materialsCreateVoice = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsCreateVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<MaterialsCreateVoiceResponse, MaterialsCreateVoiceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/voices',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * SSE 订阅音色状态变更
 */
export const materialsGetVoiceStatus = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsGetVoiceStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsGetVoiceStatusResponse,
    MaterialsGetVoiceStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/voices/status',
    ...options,
  });
};

/**
 * 列出当前用户未终态的音色复刻任务，用于前端刷新/跨页恢复
 */
export const materialsListVoiceTasks = <ThrowOnError extends boolean = false>(
  options?: Options<MaterialsListVoiceTasksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MaterialsListVoiceTasksResponse,
    MaterialsListVoiceTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/voices/tasks',
    ...options,
  });
};

/**
 * 更新音色
 */
export const materialsUpdateVoice = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsUpdateVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<MaterialsUpdateVoiceResponse, MaterialsUpdateVoiceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/voices/{voice.voice_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取音色详情
 */
export const materialsGetVoice = <ThrowOnError extends boolean = false>(
  options: Options<MaterialsGetVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<MaterialsGetVoiceResponse, MaterialsGetVoiceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/voices/{voice_id}',
    ...options,
  });
};
